var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"display":"flex","align-items":"flex-start"}},[_c('sidebar',{staticStyle:{"margin-right":"20px","max-width":"200px"}}),_c('vat-list')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }